import {register} from '../vendor/theme-scripts/theme-sections';
import tabs from '../features/tabs';
import {productSliderSection} from '../features/product-slider';
import {swatchGridSection} from '../features/swatch';

register('collection-tabs', [tabs, productSliderSection, swatchGridSection]);
